import { TooltipService } from '@_services/tooltip.service';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-property-parent-title',
  templateUrl: './property-parent-title.component.html',
  styleUrls: ['./property-parent-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PropertyParentTitleComponent implements OnInit {
  @Input() MatterPropertyDetailsForm: FormGroup;
  @Input() errorWarningData: any;
  @Input() testBool;
  @Input() toolTipList: any;
  toolTipPostion = 'above';
  constructor(public tooltipService: TooltipService) {}

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {}
  /**
   * This function is used to get the text data value
   */
  myFunction(event: any) {
    // var copyText: any = document.getElementById("myInput");
    // copyText.select();
    // copyText.setSelectionRange(0,9999);
    //  navigator.clipboard.writeText(copyText.value)
    // var copyText: any = document.getElementById("myInput");
    // event.select();
    // event.setSelectionRange(0,9999);

    navigator.clipboard.writeText(event);
  }
}
